import * as Yup from 'yup'
import { Partners } from '@shared/lib/partner'

interface GetPaymentFormValidationArgs {
  fields: Array<{ name: string; regExp?: string }> | undefined
  partner: Partners
}

export const getPaymentFormValidation = ({ fields, partner }: GetPaymentFormValidationArgs) => {
  const cdekValidationRules = {
    isPersonalDataAgreed: Yup.lazy(() => Yup.boolean().required().isTrue()),
    isMailingAgreed: Yup.lazy(() => Yup.boolean()),
  }

  return Yup.object().shape({
    ...fields?.reduce((acc, cur) => {
      if (cur.name === 'id1' || cur.name === 'email') {
        ;(acc as any).email = Yup.lazy(() =>
          Yup.string()
            .email('Некорректный email')
            .test(
              'no-cyrillic',
              'Email не может содержать русские буквы',
              (value) => !/[а-яА-ЯёЁ]/.test(value as string)
            )
            .required('Вначале заполните поле')
        )
      } else {
        acc[cur.name] = Yup.lazy(() =>
          Yup.string()
            .test('unvalid-data', 'Некорректные данные', (value) =>
              new RegExp(cur.regExp as string).test(value as string)
            )
            .required('Обязательное поле')
        )
      }

      return acc
    }, {}),
    ...(partner === Partners.CDEK ? cdekValidationRules : {}),
  })
}
